import React from 'react';
import { Link, graphql } from 'gatsby';

import Layout from '../components/Layout';
import SEO from '../components/seo';
import Authors from '../components/Authors';
import Categories from '../components/Categories';

import './blog-post.css';

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    const { previous, next } = this.props.pageContext;
    const { title, date, categories, authors, image } = post.frontmatter;
    const imageSrc = image && image.childImageSharp.fixed.src;
    return (
      <Layout>
        <SEO
          title={title}
          description={post.fields.teaserPlainText || post.excerpt}
          image={imageSrc}
        />
        <h1 className="blogPost__title">{title}</h1>
        <p className="blogPost__metadata">
          {date}{' '}
          {authors && (
            <React.Fragment>
              by <Authors authors={authors} />
            </React.Fragment>
          )}
        </p>

        <div
          className="blogPost__content"
          dangerouslySetInnerHTML={{ __html: post.html }}
        />

        {categories && (
          <aside className="blogPost__categories">
            <Categories categories={categories} />
          </aside>
        )}

        <hr className="blogPost__separator" />

        <ul className="blogPost__prevNextLinks">
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </Layout>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(format: PLAIN, pruneLength: 500)
      html
      fields {
        teaserPlainText
      }
      frontmatter {
        title
        date(formatString: "MMMM Do, YYYY")
        categories
        authors {
          name
          link
        }
        image {
          childImageSharp {
            fixed {
              src
            }
          }
        }
      }
    }
  }
`;
